(function (window, document) {
  const navUl = document.querySelector(".site-header-content .nav ul");
  if (!navUl) {
    return;
  }

  Array.from(navUl.children).forEach((li) => {
    const a = li.children[0];
    const linkPath = a.pathname.replace(/\/$/g, '');
    const documentPath = document.location.pathname.replace(/\/$/g, '');
    if (linkPath == documentPath) {
      a.classList.add("current-nav-link");
    }
  });
  
})(window, document);
